module.exports = __webpack_public_path__ + "static/media/pr.7477154a.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/pr.svg
// module id = 921
// module chunks = 0